import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var font = variables.font,
  colour = variables.colour;
export var container = /*#__PURE__*/css("margin-top:40px;margin-left:14px;font:", font.accentMediumFontSize, " ", font.headingFontFamily, ";white-space:nowrap;", media('>=tablet'), "{margin-top:80px;margin-left:18px;}", media('>=desktop'), "{margin-left:0;}");
export var cardWrapperMobile = {
  name: "autorx",
  styles: "display:flex;flex-wrap:nowrap;overflow:auto;"
};
export var wrapper = {
  name: "k008qs",
  styles: "display:flex;"
};
export var dreamHomes = {
  name: "busj1n",
  styles: "width:1016px;margin:0 auto;"
};
export var headingMobile = /*#__PURE__*/css("display:block;margin-bottom:15px;font-weight:bold;color:", colour.neutral700, ";font-size:20px;");
var afterText = /*#__PURE__*/css("display:inline-block;position:absolute;right:0;bottom:-15px;left:0;width:67px;margin:0 auto;border-top:2px solid ", colour.accent, ";content:'';");
export var headingOver = {
  name: "1yfa755",
  styles: "display:block;width:100%;height:80px;margin-right:0;text-align:center;vertical-align:top;"
};
export var headingOverText = /*#__PURE__*/css("position:relative;top:0;color:", colour.neutral700, ";font-size:22px;font-weight:bold;:after{", afterText, ";}");
export var heading = isLarge => /*#__PURE__*/css("display:inline-block;width:", isLarge ? '442px' : '320px', ";height:", isLarge ? '345px' : '251px', ";margin-right:28px;text-align:center;vertical-align:top;");
export var headingText = isLarge => /*#__PURE__*/css("position:relative;top:", isLarge ? '150px' : '90px', ";color:", colour.neutral700, ";font-size:22px;font-weight:bold;:after{", afterText, ";}");